import { Injectable } from '@angular/core';
import { CanActivate, CanActivateFn, Router } from '@angular/router';
import { LoginServicesService } from '../services/login-services.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: LoginServicesService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.isValidToken() && localStorage.getItem('data')) {
      return true;
    } else {
      sessionStorage.removeItem('authCode');  
      this.router.navigate(['/login']);
      return false;
    }
  }
}

